import { Extension, isNodeEmpty } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { Decoration, DecorationSet } from '@tiptap/pm/view';
/**
 * This extension allows you to add a placeholder to your editor.
 * A placeholder is a text that appears when the editor or a node is empty.
 * @see https://www.tiptap.dev/api/extensions/placeholder
 */

var Placeholder = Extension.create({
  name: 'placeholder',
  addOptions: function addOptions() {
    return {
      emptyEditorClass: 'is-editor-empty',
      emptyNodeClass: 'is-empty',
      placeholder: 'Write something …',
      showOnlyWhenEditable: true,
      showOnlyCurrent: true,
      includeChildren: false
    };
  },
  addProseMirrorPlugins: function addProseMirrorPlugins() {
    var _this = this;

    return [new Plugin({
      key: new PluginKey('placeholder'),
      props: {
        decorations: function decorations(_ref) {
          var doc = _ref.doc,
              selection = _ref.selection;
          var active = _this.editor.isEditable || !_this.options.showOnlyWhenEditable;
          var anchor = selection.anchor;
          var decorations = [];

          if (!active) {
            return null;
          }

          var isEmptyDoc = _this.editor.isEmpty;
          doc.descendants(function (node, pos) {
            var hasAnchor = anchor >= pos && anchor <= pos + node.nodeSize;
            var isEmpty = !node.isLeaf && isNodeEmpty(node);

            if ((hasAnchor || !_this.options.showOnlyCurrent) && isEmpty) {
              var classes = [_this.options.emptyNodeClass];

              if (isEmptyDoc) {
                classes.push(_this.options.emptyEditorClass);
              }

              var decoration = Decoration.node(pos, pos + node.nodeSize, {
                class: classes.join(' '),
                'data-placeholder': typeof _this.options.placeholder === 'function' ? _this.options.placeholder({
                  editor: _this.editor,
                  node: node,
                  pos: pos,
                  hasAnchor: hasAnchor
                }) : _this.options.placeholder
              });
              decorations.push(decoration);
            }

            return _this.options.includeChildren;
          });
          return DecorationSet.create(doc, decorations);
        }
      }
    })];
  }
});
export { Placeholder, Placeholder as default };